import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredNonZeroNumberColumn,
    FilteredDateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Operator', 'operator'),
        new FilteredTextColumn('IMPC', 'impc'),
        new FilteredDateTimeColumn('When', 'when'),
        new FilteredNonZeroNumberColumn('Adjustment', 'adjustment'),
        new FilteredTextColumn('User', 'user'),
        new FilteredNonZeroNumberColumn('ID', 'id'),
        new FilteredTextColumn('Status', 'status'),
        new FilteredTextColumn('Comment', 'comment'),
      ],
    },
  ];
};
